import removeVietnameseTones from './removeVietnameseTones'

export default function covertToSearchString(str) {
  // Nếu không phải string thì trả về nguyên giá trị
  if (typeof str !== "string") return str;

  return removeVietnameseTones(str).toLowerCase();
}
